<template>
  <div class="attribute">
    <ConditionOverview v-if="condition?.locked" v-bind="overview">
      <div class="actions">
        <NbButton variant="tertiary" icon="edit" @click="onEdit">{{
          $t("edit")
        }}</NbButton>
        <NbButton
          variant="tertiary"
          icon="trash"
          class="ml-2"
          @click="onDelete"
          >{{ $t("delete") }}</NbButton
        >
      </div>
    </ConditionOverview>

    <div v-else>
      <NbSelectInput
        v-model="values"
        :options="countries"
        id="destination-country"
      />

      <div class="d-flex justify-content-end mt-3">
        <NbButton @click="onSave" variant="secondary" :disabled="!isValid">{{
          $t("add")
        }}</NbButton>
      </div>
    </div>
  </div>
</template>

<script>
import NbButton from "../../../../../../components/buttons/NbButton.vue";
import NbSelectInput from "../../../../../../components/input/select/NbSelectInput.vue";
import shippingRulesConditionMixin from "../../../../../../mixins/shipping-rules-condition-mixin";
import ConditionOverview from "../ConditionOverview.vue";

export default {
  name: "DestinationCountry",
  mixins: [shippingRulesConditionMixin],
  components: {
    NbButton,
    ConditionOverview,
    NbSelectInput,
  },
  data() {
    return {
      countries: [{ value: "BR", text: "Brazil" }],
    };
  },
  computed: {
    values: {
      get() {
        return this.condition.values?.[0] || "";
      },
      set(val) {
        this.update({ values: [val] });
      },
    },
    isValid() {
      return this.condition?.values?.[0];
    },
    overview() {
      let info = {
        condition: "",
        operator: "",
        values: "",
      };

      if (this.condition?.locked) {
        const countryName =
          this.countries.find(
            (country) => country.value === this.condition?.values?.[0]
          )?.text || "";
        info = {
          condition: this.condition?.condition_name,
          operator: this.condition?.operator,
          values: countryName,
        };
      }

      return info;
    },
  },
};
</script>

<style lang="scss" scoped></style>
